var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNounLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5940_28502)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5940_28502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5940_28502)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6577 2.00065C14.6577 1.63246 14.3592 1.33398 13.991 1.33398H9.27698C8.90878 1.33398 8.61032 1.63246 8.61032 2.00065C8.61032 2.36884 8.90878 2.66732 9.27698 2.66732H12.3815L7.86278 7.18612C7.60238 7.44645 7.60238 7.86858 7.86278 8.12892C8.12312 8.38925 8.54518 8.38925 8.80558 8.12892L13.3243 3.61012V6.71472C13.3243 7.08285 13.6229 7.38138 13.991 7.38138C14.3592 7.38138 14.6577 7.08285 14.6577 6.71472V2.00065ZM5.17312 14.6769H10.8282C11.3648 14.6769 11.8078 14.6769 12.1685 14.6475C12.5433 14.6169 12.8877 14.5511 13.2113 14.3863C13.713 14.1307 14.121 13.7227 14.3766 13.2209C14.5415 12.8973 14.6072 12.5529 14.6378 12.1781C14.6673 11.8174 14.6673 11.3745 14.6673 10.8378V10.3436C14.6673 9.97538 14.3689 9.67692 14.0007 9.67692C13.6325 9.67692 13.334 9.97538 13.334 10.3436V10.8103C13.334 11.3813 13.3335 11.7695 13.309 12.0696C13.2851 12.3619 13.2418 12.5113 13.1887 12.6156C13.0609 12.8665 12.8569 13.0705 12.606 13.1983C12.5017 13.2514 12.3523 13.2947 12.06 13.3186C11.7599 13.3431 11.3717 13.3436 10.8007 13.3436H5.20065C4.6296 13.3436 4.2414 13.3431 3.94134 13.3186C3.64906 13.2947 3.4996 13.2514 3.39533 13.1983C3.14445 13.0705 2.94047 12.8665 2.81264 12.6156C2.75952 12.5113 2.71623 12.3619 2.69235 12.0696C2.66784 11.7695 2.66732 11.3813 2.66732 10.8103V5.21026C2.66732 4.63921 2.66784 4.25102 2.69235 3.95096C2.71623 3.65868 2.75952 3.50921 2.81264 3.40494C2.94047 3.15406 3.14445 2.95008 3.39533 2.82226C3.4996 2.76913 3.64906 2.72584 3.94134 2.70196C4.2414 2.67745 4.6296 2.67693 5.20065 2.67693H5.66732C6.03551 2.67693 6.33398 2.37845 6.33398 2.01026C6.33398 1.64208 6.03551 1.3436 5.66732 1.3436H5.1731C4.63646 1.34359 4.19356 1.34358 3.83277 1.37306C3.45804 1.40368 3.11356 1.46938 2.79001 1.63424C2.28824 1.88991 1.8803 2.29786 1.62464 2.79962C1.45977 3.12318 1.39406 3.46765 1.36344 3.84238C1.33397 4.20317 1.33398 4.64608 1.33398 5.18271V10.8378C1.33398 11.3745 1.33397 11.8174 1.36344 12.1781C1.39406 12.5529 1.45977 12.8973 1.62463 13.2209C1.8803 13.7227 2.28824 14.1307 2.79001 14.3863C3.11356 14.5511 3.45804 14.6169 3.83276 14.6475C4.19356 14.6769 4.63647 14.6769 5.17312 14.6769Z",
    fill: "#007AFF",
    stroke: "#007AFF",
    strokeWidth: 0.3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5940_28502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounLink);
export default __webpack_public_path__ + "static/media/noun-link.02784735d4e4821eeb3e42c1ad064ed5.svg";
export { ForwardRef as ReactComponent };